export interface ImageBlockBenin {
  condition: string;
  images: string[];
}

export const imageBlocksBenin: ImageBlockBenin[] = [
  {
    condition: 'ADPME',
    images: ['assets/img/FN-LOGO.png', 'assets/img/logoadpme_a_a.png'],
  },
  {
    condition: 'BATONGA',
    images: ['assets/img/BATONGA.jpeg'],
  },
  {
    condition: 'BE',
    images: ['assets/img/BE.jpeg'],
  },
  {
    condition: 'BLOLAB',
    images: ['assets/img/BLOLAB.jpeg'],
  },
  {
    condition: 'EMN',
    images: ['assets/img/EMN.jpeg'],
  },
];
